module.exports = __webpack_public_path__ + "img/alert-fail.d120d7cb.svg";